import React from 'react'
import LoaderAnimation from "../assets/Hourglass_loader.gif";

const Loader = () => {
  return (
    <div style={{display: "flex", justifyContent: "center", alignItems: 'center', width: "100vw", height: "100vh" }}><img src={LoaderAnimation} alt="loader" /></div>
  )
}

export default Loader